export default __webpack_public_path__ + "5cd885ac7cadf1dc2a513e266cc4b605.png";